"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("../styles");

var _uid = require("../utils/uid");

var _getDataset = _interopRequireDefault(require("../utils/dom/getDataset"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Tab =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Tab, _PureComponent);

  function Tab(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.getActiveStyle = _this.getActiveStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.uid = "tab_unique_" + (0, _uid.getUidStr)();
    return _this;
  }

  var _proto = Tab.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    (0, _uid.defer)(function () {
      if (_this2.props.isActive) _this2.handleClick(true);
    });
  };

  _proto.getActiveStyle = function getActiveStyle() {
    var _this$props = this.props,
        shape = _this$props.shape,
        align = _this$props.align,
        background = _this$props.background,
        color = _this$props.color,
        border = _this$props.border,
        isActive = _this$props.isActive,
        isVertical = _this$props.isVertical;
    if (shape === 'line' || shape === 'dash') return {};
    var style = {
      background: background,
      color: color
    };
    if (shape === 'bordered') return {
      background: background
    };
    if (shape !== 'line' && !isVertical) style.borderColor = border + " " + border + " " + (isActive ? background : border) + " " + border;
    if (shape !== 'line' && align === 'vertical-left') style.borderColor = border + " " + (isActive ? background : border) + "  " + border + " " + border;
    if (shape !== 'line' && align === 'vertical-right') style.borderColor = border + " " + border + " " + border + " " + (isActive ? background : border);
    return style;
  };

  _proto.handleClick = function handleClick(init) {
    var _this$props2 = this.props,
        onClick = _this$props2.onClick,
        id = _this$props2.id,
        isActive = _this$props2.isActive,
        disabled = _this$props2.disabled,
        last = _this$props2.last;
    if (disabled) return;
    if (init !== true) onClick(id, isActive);

    if (!this.element) {
      this.element = document.querySelector("." + this.uid);
    }

    if (this.element && this.element.getBoundingClientRect) {
      this.props.moveToCenter(this.element.getBoundingClientRect(), last, id === 0);
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        isActive = _this$props3.isActive,
        disabled = _this$props3.disabled,
        children = _this$props3.children,
        shape = _this$props3.shape,
        otherProps = _objectWithoutPropertiesLoose(_this$props3, ["isActive", "disabled", "children", "shape"]);

    var style = this.getActiveStyle();
    var isBordered = shape === 'bordered';

    var props = _objectSpread({
      className: (0, _classnames.default)((0, _styles.tabsClass)('tab', isActive && (isBordered ? 'tab-bordered-active' : 'active'), disabled && 'disabled', isBordered && 'tab-bordered'), this.uid),
      onClick: this.handleClick,
      style: style
    }, (0, _getDataset.default)(otherProps));

    if (children.type && children.type.isTabLink) {
      return _react.default.cloneElement(children, _objectSpread({}, props));
    }

    return _react.default.createElement("div", props, children);
  };

  return Tab;
}(_react.PureComponent);

Tab.propTypes = {
  background: _propTypes.default.string,
  border: _propTypes.default.string,
  children: _propTypes.default.any,
  color: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  isVertical: _propTypes.default.bool,
  id: _propTypes.default.any.isRequired,
  isActive: _propTypes.default.bool.isRequired,
  moveToCenter: _propTypes.default.func.isRequired,
  onClick: _propTypes.default.func.isRequired,
  shape: _propTypes.default.string,
  align: _propTypes.default.oneOf(['left', 'right', 'vertical-left', 'vertical-right']),
  last: _propTypes.default.bool
};
Tab.defaultProps = {
  border: 'transparent'
};
var _default = Tab;
exports.default = _default;